import { Reveal } from "../components/Reveal";
import { PageHero } from "../components/PageHero";
import { IMG } from "../lib/site";
import { useT } from "../context/LangContext";

export default function ChiSiamo() {
  const { t } = useT();
  const c = t.about;
  return (
    <>
      <PageHero kicker={c.heroKicker} titleLines={c.heroTitleLines} intro={c.heroIntro} />

      <section className="mx-auto max-w-7xl px-5 md:px-8 py-10 md:py-14 grid gap-10 md:grid-cols-12 items-center" data-testid="mission">
        <Reveal className="md:col-span-6">
          <span className="font-display font-bold tracking-widest text-xs text-forest">{c.missionKicker}</span>
          <h2 className="mt-4 font-display font-extrabold tracking-tighter text-3xl md:text-4xl text-ink">{c.missionTitle}</h2>
          <p className="mt-6 text-stone leading-relaxed">{c.missionP1}</p>
          <p className="mt-4 text-stone leading-relaxed">{c.missionP2}</p>
        </Reveal>
        <Reveal delay={0.15} className="md:col-span-6">
          <div className="relative overflow-hidden rounded-[2rem] aspect-[4/3]">
            <img src={IMG.chiSiamo} alt={c.missionTitle} className="h-full w-full object-cover" style={{ objectPosition: "72% 40%" }} />
          </div>
        </Reveal>
      </section>

      <section className="bg-sand" data-testid="values">
        <div className="mx-auto max-w-7xl px-5 md:px-8 py-10 md:py-14">
          <Reveal className="mb-10 max-w-2xl">
            <span className="font-display font-bold tracking-widest text-xs text-forest">{c.valuesKicker}</span>
            <h2 className="mt-4 font-display font-extrabold tracking-tighter text-3xl md:text-4xl text-ink">{c.valuesTitle}</h2>
          </Reveal>
          <div className="grid gap-px bg-border border border-border sm:grid-cols-2 lg:grid-cols-4">
            {c.values.map((v, i) => (
              <Reveal key={v} delay={(i % 4) * 0.05} className="bg-bone">
                <div className="p-7 h-full">
                  <div className="font-serif text-2xl text-terracotta mb-3">0{i + 1}</div>
                  <p className="font-display font-bold tracking-tight text-ink leading-snug">{v}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
